export default __webpack_public_path__ + "static/btn_img_4-ef9f3426d34247492fd016d7a21d5d1c.jpg";